import bar2dAnimation from'../bar2d/index.animation';export default{"initial.dataset.bar3D":bar2dAnimation['initial.dataset.bar2D']};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/dataset/bar3d/index.animation.js
// module id = null
// module chunks = 